<template>
    <div class="notice-page">
        <!-- PC 端 招聘公告图片 -->
        <div class="notice-pc" v-show="isPC">
            <img src="../../assets/notice-pc.jpg" alt="招聘公告" />
        </div>

        <!-- 移动端 招聘公告图片 -->
        <div class="notice-mobile" v-show="!isPC">
            <img src="../../assets/notice-mobile.jpg" alt="招聘公告" />
        </div>
        <!-- <div class="page-title">
        <h2>招聘公告</h2>
        <p class="en-title">JOB ANNOUNCEMENTS</p>
      </div>
      <div class="content">
        <p>湖北港口集团是湖北省港口航运投资、建设、运营主体，致力于加快建成国内一流航运枢纽、一流港口企业、一流开放通道，形成了港口服务、综合物流、临港园区开发运营三大业务板块。</p>
  
        <div class="section">
          <h3 class="section-title">一、招聘对象</h3>
          <p>国（境）内外普通高等院校2026届、2025届和2024届毕业生。</p>
        </div>
  
        <div class="section">
          <h3 class="section-title">二、资格条件</h3>
          <div class="sub-section">
            <h4>（一）毕业时间</h4>
            <p>国内院校毕业生应于2026年7月31日前毕业并取得相应学历学位证书；国（境）外院校毕业生应于2026年7月31日前取得教育部留学服务中心学历学位认证。</p>
          </div>
          <div class="sub-section">
            <h4>（二）年龄要求</h4>
            <p>本科生不超过25周岁（2000年1月1日及以后出生），硕士研究生不超过28周岁（1997年1月1日及以后出生），博士研究生原则上不超过33周岁（1992年1月1日及以后出生）。</p>
          </div>
        </div>
      </div> -->
    </div>
</template>


<script>
export default {
    name: "TabNotice",
    data() {
        return {
            isPC: true,
        };
    },
    mounted() {
        this.onResize();
        window.addEventListener("resize", this.onResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    methods: {
        onResize() {
            this.isPC = window.innerWidth >= 992;
        },
    },
};
</script>

<style scoped lang="less">
.notice-page {
    width: 100%;

    img {
        width: 100%;
        height: auto;
        display: block;
    }

    // .page-title {
    //   text-align: center;
    //   margin-bottom: 24px;
    //   position: relative;
    //   &::before {
    //     content: 'JOB ANNOUNCEMENTS';
    //     position: absolute;
    //     top: 50%;
    //     left: 50%;
    //     transform: translate(-50%, -50%);
    //     font-size: 36px;
    //     color: #eee;
    //     z-index: 0;
    //   }
    //   h2 {
    //     position: relative;
    //     font-size: clamp(20px, 4vw, 28px);
    //     color: #0056b3;
    //     z-index: 1;
    //     &::after {
    //       content: '';
    //       display: block;
    //       width: 60px;
    //       height: 4px;
    //       background: #ffc107;
    //       margin: 8px auto 0;
    //     }
    //   }
    //   .en-title {
    //     font-size: 14px;
    //     color: #999;
    //   }
    // }
    // .content {
    //   line-height: 1.8;
    //   font-size: clamp(14px, 3vw, 16px);
    //   color: #333;
    //   p {
    //     margin-bottom: 16px;
    //     text-indent: 2em;
    //   }
    //   .section {
    //     margin-top: 24px;
    //     .section-title {
    //       display: inline-block;
    //       background: #d9b38c;
    //       color: #fff;
    //       padding: 4px 16px;
    //       border-radius: 20px;
    //       font-size: 18px;
    //       margin-bottom: 12px;
    //     }
    //     .sub-section {
    //       margin-left: 20px;
    //       margin-top: 12px;
    //       h4 {
    //         font-size: 16px;
    //         margin-bottom: 8px;
    //       }
    //     }
    //   }
    // }
}
</style>